/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgQrCode = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M5 5h3v3H5z" />
        <path d="M2 2h9v9H2zm2 2v5h5V4zm12 1h3v3h-3z" />
        <path d="M13 2h9v9h-9zm2 2v5h5V4zM8 15H5v3h3z" />
        <path d="M2 12h9v9H2zm2 2v5h5v-5zm11 7v-9h-2v9zm1-7h4v2h-4v2h4v3h2v-9h-6z" />
        <path d="M16 21h2v-2h-2z" />
      </g>
    </g>
  </Icon>
);
export { SvgQrCode as QrCode };
